// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBarBottom_wrapper__SfK9G","dropDownHover":"NavBarBottom_dropDownHover__KnaQi","dropbtn":"NavBarBottom_dropbtn__54Ws-"};